<script setup>
import {
  defineComponent,
  defineProps,
  ref,
  reactive,
  computed,
  onMounted,
  onUnmounted,
} from "vue";

const props = defineProps(["list"]);
const list = ref([]);
const getSwite = async () => {
  await nextTick();
  const res = await useFetch(constants.BASE_URL + api.getBannerList, {
    method: "GET",
  });
  console.log(res, "list");
  list.value = res?.data?._rawValue?.data;
  console.log(list.value, "list");
};
getSwite();
const currentIndex = ref(0);

const activeImages = computed(() => list.value[currentIndex.value]);

const prevImage = () => {
  currentIndex.value =
    (currentIndex.value - 1 + list.value.length) % list.value?.length;
  console.log("123", currentIndex.value, list);
};

const nextImage = () => {
  currentIndex.value = (currentIndex.value + 1) % list.value?.length;
  console.log("123", currentIndex.value);
};

const goPay = (item) => {
  console.log(item);
  navigateTo("/product/" + item.goodsCode);
};

const goContact = () => {
  window.open("https://www.greenvalleyintl.com/contactNew", "_blank");
};

onUnmounted(() => {});
</script>

<template>
  <div class="carousel-container" v-if="list">
    <div class="carousel-wrapper">
      <NuxtImg
        class="img"
        :src="activeImages?.file?.fileUrl"
        alt="Carousel Image"
      />
      <div class="carousel-conntext">
        <div class="title">{{ activeImages?.title }}</div>
        <div class="describe">{{ activeImages?.describe }}</div>
        <div class="btns">
          <img
            class="contact"
            src="../../assets/imgs/index/findADealer.png"
            alt=""
            @click="goContact()"
          />

          <img
            class="buy"
            src="../../assets/imgs/index/buy.png"
            alt=""
            @click="goPay(activeImages)"
          />
        </div>
      </div>
      <div class="carousel-controls">
        <img src="../../assets/imgs/index/go1.png" @click="prevImage" />
        <img src="../../assets/imgs/index/go2.png" @click="nextImage" />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.carousel-container {
  width: 100%;
  // height: 800px;
  overflow: hidden;
  z-index: 1;
}
.carousel-wrapper {
  position: relative;
}
.carousel-wrapper img {
  width: 100%;
  height: 39.06vw;
  // max-height: 750px;
}

.carousel-controls {
  position: absolute;
  // bottom: 50%;
  top: 41%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  width: 90%;
}

.carousel-controls img {
  width: 2.6vw;
  height: 2.6vw;
  min-width: 40px;
  min-height: 40px;
  line-height: 1.5vw;
  color: #fff;
  border: none;
  cursor: pointer;
}

.carousel-conntext {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  .title {
    .fcf(100,#fff);
    line-height: 6.25vw;
    margin-bottom: 2.1vw;
  }
  .describe {
    .fcf(40,#eee);
    line-height: 40px;
    text-align: center;
    margin-bottom: 1.5vw;
  }
  .btns {
    .buy,
    .contact {
      width: 7.5vw;
      height: 2.7vw;
      min-width: 75px;
      min-height: 25px;
      cursor: pointer;
    }

    .buy {
      margin-left: 20px;
    }
  }
}

@media (max-width: 1024px) {
  .carousel-conntext {
    .title {
      .fcf(40,#fff);
    }
    .describe {
      display: none;
    }
    .buy {
      margin-top: 5vw;
    }
  }
}
</style>
